export enum FolderContext {
  individual = 1,
  pedigree = 2,
  inviteQueryFolder=12,
}
